export const getParamFromUrl = (url: string, key: string): string | null => {
    return new URLSearchParams(url).get(key);
}

export const hasParam = (url: string, key: string): boolean => {
    return new URLSearchParams(url).has(key);
}